import { render, staticRenderFns } from "./BpmnTreeList.vue?vue&type=template&id=89721ed2&scoped=true&"
import script from "./BpmnTreeList.vue?vue&type=script&lang=js&"
export * from "./BpmnTreeList.vue?vue&type=script&lang=js&"
import style0 from "./BpmnTreeList.vue?vue&type=style&index=0&id=89721ed2&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89721ed2",
  null
  
)

export default component.exports